/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react'; // eslint-disable-line
import { Grid, Tooltip, Button } from '@material-ui/core';
import { ButtonWrapper, FullWidthTextField } from '../../../../../../forms';
import { requiredValidator } from '../../../../../../forms/validations';
import { Delete, AddCircle } from '@material-ui/icons';
import { Beneficiary } from '../../reducer';

interface ComponentState {
    beneficiaries: Beneficiary[];
}
interface BeneficiariesProps {
    classes: any;
    beneficiaries: Beneficiary[];
}
export class UpdateBeneficiariesView extends React.Component<BeneficiariesProps, ComponentState> {
    public constructor(props: BeneficiariesProps) {
        super(props);
        if (props.beneficiaries === null) {
            this.setState({
                beneficiaries: [],
            });
        }
    }
    public render() {
        let beneficiaries = this.props.beneficiaries ? this.props.beneficiaries : [];
        if (beneficiaries.length === 0) {
            beneficiaries = this.state ? this.state.beneficiaries : [];
        }
        const classes = this.props.classes;
        const addEntry = () => {
            beneficiaries.push({});
            this.setState({
                beneficiaries: beneficiaries,
            });
            this.forceUpdate();
        };
        const deleteEntry = (index: number) => {
            beneficiaries.splice(index, 1);
            this.setState({
                beneficiaries: beneficiaries,
            });
            this.forceUpdate();
        };
        return (
            <React.Fragment>
                {beneficiaries.map((_pm, index) => {
                    return (
                        <Grid item container spacing={5} key={`pm_${index}`}>
                            <Grid item xs={6}>
                                <FullWidthTextField
                                    name={`beneficiaries[${index}].firstName`}
                                    validate={requiredValidator}
                                />
                            </Grid>
                            <Grid item xs={5}>
                                <FullWidthTextField
                                    name={`beneficiaries[${index}].lastName`}
                                    validate={requiredValidator}
                                />
                            </Grid>
                            <ButtonWrapper>
                                <Grid item xs={1}>
                                    <Tooltip
                                        title="Delete beneficiary"
                                        style={{
                                            marginTop: '30px',
                                            marginLeft: '-30px',
                                        }}
                                    >
                                        <Button
                                            id={`Delete_beneficiary_${index}`}
                                            color="secondary"
                                            onClick={() => deleteEntry(index)}
                                        >
                                            <Delete />
                                        </Button>
                                    </Tooltip>
                                </Grid>
                            </ButtonWrapper>
                        </Grid>
                    );
                })}
                <Grid container spacing={0} justify="flex-end" className={classes.marginTop3}>
                    <ButtonWrapper>
                        <Tooltip title="Add Beneficiary">
                            <Button
                                id="AddExternalPolicy"
                                color="secondary"
                                className={classes.button}
                                style={{ textTransform: 'none' }}
                                onClick={() => addEntry()}
                            >
                                <AddCircle />
                                Add Beneficiary
                            </Button>
                        </Tooltip>
                    </ButtonWrapper>
                </Grid>
            </React.Fragment>
        );
    }
}
